module.exports = __webpack_public_path__ + "img/7.4ba8154c.jpg";